import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

export const envs: typeof process.env = publicRuntimeConfig;
